import buildProgressMessages from '../../../helpers/buildProgressMessages';
import Confetti from 'react-confetti';
import useWindowSize from 'react-use/lib/useWindowSize';
import Link from 'next/link';

export default function BuildMessage({ buildProgress, blogDeploymentState }) {
  const { width, height } = useWindowSize();

  const {
    buildProgress1,
    buildProgress2,
    buildProgress3,
    buildProgress4,
    buildProgress5,
    buildProgress6,
    buildFailed,
  } = buildProgressMessages();

  let buildMessage = buildProgress1;
  if (buildProgress > 8) buildMessage = buildProgress2;
  if (buildProgress > 18) buildMessage = buildProgress3;
  if (buildProgress > 28) buildMessage = buildProgress4;
  if (buildProgress > 40) buildMessage = buildProgress5;
  if (buildProgress > 55) buildMessage = buildProgress6;
  if (buildProgress > 85)
    buildMessage =
      'Your blog is almost there! Just waiting for the final touches to be added, like glitter and confetti.';

  if (buildProgress >= 100)
    buildMessage =
      blogDeploymentState === 'READY' ? (
        <>
          Hooray, your travel blog has successfully reached the world wide web!
          <Confetti width={width} height={height} recycle={false} />
        </>
      ) : (
        <span className="highlightLinks">
          {buildFailed} Try saving again and{' '}
          <Link href="/about/contact?support=true">contact support</Link> if the
          issue persists.
        </span>
      );
  return buildMessage;
}
